import { useState } from "@discovery/common-dplus/lib/hooks";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as RemoveItem from "@discovery/sonic-api-ng/lib/api/playback/report-playback";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { _emptyResonpnse } from "../../../component-creators/optics";
import { PremiumCarousel } from "../../molecules/premium-carousel";
import { Toast } from "../../molecules/toast";
import { RailTypes } from "../../../component-creators/rails";
import { Rail } from "../../molecules/rail";
import { ShowOfTheMonth } from "./standalone-card";
import * as styles from "./styles.css";
import { useUser } from "../../../utils/hooks";
const getContainerStyles = (railType) => {
    switch (railType) {
        case RailTypes.CategoryCard:
        case RailTypes.SquarLogo:
            return styles.categoryDesktopGridContainer;
        case RailTypes.PremiumCarousel:
            return styles.desktopGridContainer;
        case RailTypes.FeaturedStandalone:
            return styles.desktopGridContainerM;
        default:
            return styles.desktopGridContainer;
    }
};
const getRailContainerStyles = (railType) => {
    switch (railType) {
        case RailTypes.CategoryCard:
            return styles.categoryCarouselGradient;
        default:
            return "";
    }
};
export const Rails = (props) => {
    const { cards, railType, title, webAuthRedirectionUrl, gridID, kebabMenuItemHandler, ageConstraint, BannerId, bannerAdPlaceholder, channelTitle, showTitle, genreCategory, isAdsEnabled, read, hideViewAll, viewAllRouteM, } = props;
    const [toastMsg, setToastMsg] = useState("");
    const [cardData, setCardData] = useState(cards);
    const [showToastMsg, setShowToastMsg] = useState(false);
    const [successFlag, setSuccessFlag] = useState(false);
    const [, setCardReset] = useState(false);
    const { isAnonymous, premiumPackagesM } = useUser();
    const removeItem = (id) => {
        const card = document.getElementById(`${id}`);
        if (card && card.parentElement) {
            card.style.opacity = "1";
            card.style.display = "flex";
        }
        setMsg("We have removed successfully from Continue Watching", true);
        setCardData([...cardData.filter((card) => card.id !== id)]);
    };
    const setMsg = (message, successFlag) => {
        setToastMsg(message);
        setShowToastMsg(true);
        setSuccessFlag(successFlag);
        setTimeout(() => {
            setShowToastMsg(false);
        }, 2000);
    };
    const removeFromContinueWatch = (id) => {
        if (read) {
            const postRequest = RemoveItem.Endpoints.deleteFromPlayback(id);
            App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
                () => {
                    setMsg("Error saving your preference. Please retry", false);
                };
            }, (response) => {
                const errorCodeM = Fold.preview(_emptyResonpnse, response);
                const errorCode = M.fromMaybe(errorCodeM, "");
                if (errorCode !== "400") {
                    const card = document.getElementById(`${id}`);
                    if (card && card.parentElement) {
                        card.style.opacity = "0%";
                        setTimeout(() => {
                            if (card && card.parentElement) {
                                card.style.display = "none";
                            }
                        }, 1000);
                    }
                    setTimeout(() => {
                        setCardReset(true);
                        removeItem(id);
                    }, 1005);
                }
                else {
                    setMsg("Error saving your preference. Please retry", false);
                }
            }));
        }
    };
    const _viewAllRoute = M.fromMaybe(viewAllRouteM, "");
    const nativeViewAllUrl = railType !== RailTypes.SuperStars
        ? _viewAllRoute === undefined || _viewAllRoute === ""
            ? config.standardPageRouteFragments.nativeViewAll + "?id=" + gridID
            : _viewAllRoute
        : config.standardPageRouteFragments.nativeViewAll +
            "?id=" +
            gridID +
            "&isSuperStar=true";
    const RailTypeBasedRails = () => {
        switch (railType) {
            case RailTypes.PremiumCarousel:
                return (React.createElement(PremiumCarousel, { data: cards.slice(0, 15), autoplay: 5000, loop: cards.length > 1, anonymous: isAnonymous, premiumPackages: M.fromMaybe(premiumPackagesM, []), ageConstraint: ageConstraint }));
            case RailTypes.FeaturedStandalone:
                return (React.createElement("div", null,
                    React.createElement("div", { className: styles.standAloneWrapper },
                        React.createElement(ShowOfTheMonth, { cards: cards, title: title }))));
            default:
                return (React.createElement(Rail, { cards: railType === RailTypes.DescriptiveWithProgress ? cardData : cards, railType: railType, webAuthRedirectionUrl: webAuthRedirectionUrl, kebabMenuItemHandler: kebabMenuItemHandler, nativeViewAllUrl: nativeViewAllUrl, gridID: gridID, title: title, ageConstraint: ageConstraint, BannerId: BannerId, bannerAdPlaceholder: bannerAdPlaceholder, channelTitle: channelTitle, showTitle: showTitle, genreCategory: genreCategory, isAdsEnabled: isAdsEnabled, read: read, hideViewAll: hideViewAll, removeFromContinueWatch: removeFromContinueWatch }));
        }
    };
    const isAdRendered = localStorage.getItem("isAdRendered");
    return (React.createElement("div", { className: isAdRendered ? styles.main : "" }, cards && cards.length > 0 && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: getRailContainerStyles(railType) },
            React.createElement("div", { className: getContainerStyles(railType) },
                React.createElement(RailTypeBasedRails, null))),
        showToastMsg && (React.createElement(Toast, { toastMsg: toastMsg, successFlag: successFlag, onClick: () => setShowToastMsg(false) }))))));
};

